import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=b2fbbcc6&scoped=true&"
import script from "./Project.vue?vue&type=script&lang=ts&"
export * from "./Project.vue?vue&type=script&lang=ts&"
import style0 from "./Project.vue?vue&type=style&index=0&id=b2fbbcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fbbcc6",
  null
  
)

export default component.exports